import { Grid } from '@material-ui/core';

import SkeletonLoading from '../SkeletonLoading';

import requestFieldsConfig from './fields/request.fields.config';
import requestFieldsService from '../../domain/services/request/request.fields.service';
import utilsProvider from '../providers/utils.provider';

export default function RequestProcessInformation(props) {

    const { request, stepFields, isEdit } = props;

    const dependencyFieldValidation = (field) => {

        const dependencyFieldValueA = request[field.dependencyField];
        const dependencyFieldValueB = ((request?.fields || {})[field.dependencyField]?.values || [])[0]?.value;
        const dependencyFieldValueC = request.fields[field.dependencyField]?.value;

        const dependencyValue = field.dependencyValue || 'true';
        const result = (!field.dependencyField || utilsProvider.checkStringContains(dependencyFieldValueA, dependencyValue) || utilsProvider.checkStringContains(dependencyFieldValueB, dependencyValue) || utilsProvider.checkStringContains(dependencyFieldValueC, dependencyValue));

        return result
    }

    return (
        <SkeletonLoading
            isDataLoading={!request.id || !stepFields.length}
            variant='rect' size={{ height: 110 }}
        >
            <Grid
                container spacing={8}
                style={requestFieldsService.checkDisableFieldsStyle(request, isEdit)}
            >
                {stepFields
                    .filter(field => dependencyFieldValidation(field))
                    .map(field => ({
                        ...requestFieldsConfig.getComponentField({ ...props, field })
                    }))}
            </Grid>
        </SkeletonLoading>
    );
}